export var DocumentActionTypes;
(function (DocumentActionTypes) {
    DocumentActionTypes["FETCH_DOCUMENTS_ATTEMPT"] = "FETCH_DOCUMENTS_ATTEMPT";
    DocumentActionTypes["FETCH_DOCUMENTS_SUCCESS"] = "FETCH_DOCUMENTS_SUCCESS";
    DocumentActionTypes["FETCH_DOCUMENTS_FAILURE"] = "FETCH_DOCUMENTS_FAILURE";
    DocumentActionTypes["DOWNLOAD_DOCUMENT_ATTEMPT"] = "DOWNLOAD_DOCUMENT_ATTEMPT";
    DocumentActionTypes["DOWNLOAD_DOCUMENT_SUCCESS"] = "DOWNLOAD_DOCUMENT_SUCCESS";
    DocumentActionTypes["DOWNLOAD_DOCUMENT_FAILURE"] = "DOWNLOAD_DOCUMENT_FAILURE";
})(DocumentActionTypes || (DocumentActionTypes = {}));
